export default "__VITE_ASSET__Dh49zoLP__"